import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { useToast, useAIRoleBuilderTasksContext } from "hooks";
import { AIRoleBuilderForm } from "components/Missions/Roles/AIRoleBuilder";

/**
 * AIRoleBuilderModal
 *
 * Input step only. Submitting queues the request and closes the modal; progress and
 * the review action live in AIRoleBuilderTasksList, so the user is free to submit
 * another request straight away.
 *
 * @param {boolean}   show        Whether the modal is visible
 * @param {function}  onClose     Function to call when modal should be closed
 */
const AIRoleBuilderModal = ({ show, onClose, ...props }) => {
  const { submitTask } = useAIRoleBuilderTasksContext();
  const { toast } = useToast();

  const handleComplete = (mutationResult) => {
    submitTask(mutationResult);
    toast.success(<FormattedMessage id="AIRoleBuilder.Form.SubmissionSuccess" />);
    onClose();
  };

  return <AIRoleBuilderForm onCompleted={handleComplete} show={show} onClose={onClose} {...props} />;
};

AIRoleBuilderModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AIRoleBuilderModal;
